"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetEditorialProducts = void 0;
var _environment = require("@ori/environment");
var _infinite = require("@ori/fetching/infinite");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _tsUtils = require("@ori/ts-utils");
var _react = require("react");
var _constants = require("../constants");
var _getEditorialProducts = require("./getEditorialProducts");
/* istanbul ignore file @preserve */

const useGetEditorialProducts = ({
  productCodes,
  enabled
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    loading: loadingSegmentationData,
    atpClusterId,
    customerTypeId,
    visitorSegment
  } = (0, _presentationHttp.useUserSegmentationData)();
  const staticApiClient = (0, _staticApiClientReact.useApiClient)();
  const fetchParams = (0, _react.useMemo)(() => ({
    lang: language,
    atpClusterId: atpClusterId ?? undefined,
    customerTypeId: customerTypeId ?? undefined,
    visitorSegment: visitorSegment ?? undefined
  }), [atpClusterId, customerTypeId, language, visitorSegment]);
  const {
    size,
    isValidating,
    data: fetchedProducts = [],
    setSize
  } = (0, _infinite.useSWRInfinite)(pageIndex => {
    if (loadingSegmentationData || !enabled) {
      return null;
    }
    const paginationLimit = pageIndex === 0 ? _constants.PRODUCTS_PAGINATION_LIMIT_FIRST_PAGE : _constants.PRODUCTS_PAGINATION_LIMIT;
    const newLoadedRecords = pageIndex === 0 ? 0 : _constants.PRODUCTS_PAGINATION_LIMIT_FIRST_PAGE + (pageIndex - 1) * _constants.PRODUCTS_PAGINATION_LIMIT;
    const newProductCodes = productCodes.slice(newLoadedRecords, newLoadedRecords + paginationLimit);
    return {
      fetchParams,
      productCodes: newProductCodes,
      tenant,
      staticApiClient,
      isAnonymousUser: customerTypeId == null || customerTypeId === 0
    };
  }, _getEditorialProducts.getEditorialProducts, {
    ...(0, _presentationUtils.getRetryErrorSwrInfiniteOptions)(),
    revalidateFirstPage: false
  });
  const loadMoreItems = (0, _react.useCallback)(async () => {
    await setSize(prevSize => prevSize + 1);
  }, [setSize]);
  const products = (0, _react.useMemo)(() => fetchedProducts.flat().filter(_tsUtils.isNonNullable), [fetchedProducts]);
  return (0, _react.useMemo)(() => ({
    isLoadingMore: size > 0 && isValidating,
    isRefreshing: products.length === 0 && isValidating,
    products,
    loadMoreItems
  }), [isValidating, loadMoreItems, products, size]);
};
exports.useGetEditorialProducts = useGetEditorialProducts;
